module.exports = __webpack_public_path__ + "static/img/successDetail1.2cc3eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successDetail1.png
// module id = BJ8+
// module chunks = 2